function AppFooterCopyright() {
	return (
		<div className="font-general-regular flex justify-center items-center text-center">
			<div className="text-lg text-ternary-dark dark:text-ternary-light">
				&copy; {new Date().getFullYear()}
				<span className="text-secondary-dark dark:text-secondary-light font-medium ml-1">
					Shahbaz Ali
				</span>
				<span className="ml-1">•</span>
				<span className="ml-1 text-sm text-gray-500 dark:text-gray-400">
					Full-Stack Software Engineer
				</span>
			</div>
		</div>
	);
}

export default AppFooterCopyright;
